import { render } from "./page.vue?vue&type=template&id=3291c662"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\dmcloud-v3\\nms-online-nacos-dev\\nms-online\\redirect-service\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__